




























































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import { storeRujukanDotsHiv } from "@/store/modules/RujukanDotsHivStore";
import RujukanDotsHivSvc from "@/services/RujukanDotsHiv";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { userModule } from "@/store/modules/user";
import { storePasien } from "@/store/modules/pasien";
import { appModule } from "@/store/modules/app";
import { getHumanDateTime } from "@/utility/DateUtils";

@Component({
  components: {
    CardModalTtd
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardRujukanDotsHiv extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  showForm = false;
  showDetail = false;
  isEditing = false;
  editingId: number | null = null;
  saving = false;
  stepper = 1;
  detailData: any = null;
  modalTtd = false;
  signPhase: "konselor" | "dokter" = "konselor";
  dateMenu = false;

  form: any = this.getEmptyForm();

  headers = [
    { text: "Tanggal", value: "tanggal", sortable: false },
    { text: "Status", value: "status", sortable: false },
    { text: "Konselor", value: "konselor", sortable: false },
    { text: "Dokter Peminta", value: "dokter", sortable: false },
    { text: "Aksi", value: "aksi", sortable: false, width: 160 },
  ];

  getEmptyForm() {
    return {
      // Consent
      consent_bersedia: null as boolean | null,
      signed_pasien_ack: false,
      // Permintaan Lab
      kode_klien: "",
      tanggal_permintaan: localISODate(),
      skrining_sudah_ttd: false,
      skrining_risiko_aids: false,
      skrining_gejala_aids: false,
      status_tb: "",
      catatan_tambahan: "",
    };
  }

  // Getters

  get stateList() {
    return storeRujukanDotsHiv.list;
  }

  get loading() {
    return storeRujukanDotsHiv.loading;
  }

  get stateuser() {
    return userModule.user;
  }

  get autoTelp() {
    return storePasien.identitasPasien?.telp || "-";
  }

  get canMakeRujukan() {
    if (this.readOnly) return false;
    return ["dokter", "perawat", "bidan"].includes(
      this.stateuser.profesi?.toLowerCase()
    );
  }

  get isConsentLocked() {
    return this.detailData?.signed_konselor && this.detailData?.signed_pasien;
  }

  get isConsentBersedia() {
    return this.isConsentLocked && this.detailData?.consent_bersedia === true;
  }

  get isFormOneLocked() {
    return this.detailData?.signed_dokter;
  }

  get canSignKonselor() {
    if (!this.detailData || !this.detailData.id) return false;
    if (this.detailData.signed_konselor) return false;
    if (this.form.consent_bersedia === null) return false;
    if (!this.form.signed_pasien_ack) return false;
    return this.canMakeRujukan;
  }

  get canSignDokter() {
    if (!this.detailData || !this.detailData.id) return false;
    if (!this.isConsentBersedia) return false;
    if (this.detailData.signed_dokter) return false;
    return this.canMakeRujukan;
  }

  // Lifecycle

  async mounted() {
    await storeRujukanDotsHiv.getByRegister(this.register);
  }

  // Helpers

  formatDate(date) {
    return getHumanDateTime(date);
  }

  formatYaTidak(val) {
    if (val === true) return "YA";
    if (val === false) return "TIDAK";
    return "-";
  }

  getStatusColor(item) {
    switch (item.status) {
      case "selesai": return "green";
      case "permintaan_draft": return "blue";
      case "consent_tidak_bersedia": return "red";
      case "consent_draft": return "orange";
      default: return "grey";
    }
  }

  getStatusLabel(item) {
    switch (item.status) {
      case "selesai": return "Selesai";
      case "permintaan_draft": return "Permintaan Draft";
      case "consent_tidak_bersedia": return "Tidak Bersedia";
      case "consent_draft": return "Consent Draft";
      default: return "Draft";
    }
  }

  isItemFullySigned(item) {
    return item.signed_konselor && item.signed_pasien && item.signed_dokter;
  }

  hasItemSignature(item) {
    return item.signed_konselor || item.signed_pasien || item.signed_dokter;
  }

  // Form Actions

  openForm() {
    this.form = this.getEmptyForm();
    this.detailData = null;
    this.isEditing = false;
    this.editingId = null;
    this.stepper = 1;
    this.showForm = true;
  }

  async openEdit(item) {
    const resp = await RujukanDotsHivSvc.find(item.id);
    if (resp.data.status == "1") {
      this.detailData = resp.data.data;
      this.form = {
        consent_bersedia: this.detailData.consent_bersedia,
        signed_pasien_ack: this.detailData.signed_pasien,
        kode_klien: this.detailData.kode_klien || "",
        tanggal_permintaan: this.detailData.tanggal_permintaan || localISODate(),
        skrining_sudah_ttd: this.detailData.skrining_sudah_ttd || false,
        skrining_risiko_aids: this.detailData.skrining_risiko_aids || false,
        skrining_gejala_aids: this.detailData.skrining_gejala_aids || false,
        status_tb: this.detailData.status_tb || "",
        catatan_tambahan: this.detailData.catatan_tambahan || "",
      };
      this.isEditing = true;
      this.editingId = item.id;
      this.stepper = this.detailData.signed_konselor && this.detailData.signed_pasien ? 2 : 1;
      this.showForm = true;
    }
  }

  async openDetail(item) {
    const resp = await RujukanDotsHivSvc.find(item.id);
    if (resp.data.status == "1") {
      this.detailData = resp.data.data;
      this.showDetail = true;
    }
  }

  closeForm() {
    this.showForm = false;
    this.form = this.getEmptyForm();
    this.detailData = null;
    this.isEditing = false;
    this.editingId = null;
  }

  async simpanConsent() {
    this.saving = true;
    const payload = {
      register_id: this.register,
      pasien_rm: this.rm,
      consent_bersedia: this.form.consent_bersedia,
    };

    try {
      let resp;
      if (this.isEditing && this.editingId) {
        resp = await RujukanDotsHivSvc.update(this.editingId, payload);
      } else {
        resp = await RujukanDotsHivSvc.create(payload);
      }

      if (resp.data.status == "1") {
        const created = resp.data.data;
        this.editingId = created.id;
        this.isEditing = true;
        // Refresh detail
        const detailResp = await RujukanDotsHivSvc.find(created.id);
        if (detailResp.data.status == "1") {
          this.detailData = detailResp.data.data;
        }
        appModule.NoticeDelay("Consent berhasil disimpan");
        storeRujukanDotsHiv.getByRegister(this.register);
      }
    } finally {
      this.saving = false;
    }
  }

  async simpanPermintaan() {
    this.saving = true;
    const payload = {
      register_id: this.register,
      pasien_rm: this.rm,
      kode_klien: this.form.kode_klien,
      tanggal_permintaan: this.form.tanggal_permintaan,
      skrining_sudah_ttd: this.form.skrining_sudah_ttd,
      skrining_risiko_aids: this.form.skrining_risiko_aids,
      skrining_gejala_aids: this.form.skrining_gejala_aids,
      status_tb: this.form.status_tb,
      catatan_tambahan: this.form.catatan_tambahan,
    };

    try {
      if (this.editingId) {
        const resp = await RujukanDotsHivSvc.update(this.editingId, payload);
        if (resp.data.status == "1") {
          appModule.NoticeDelay("Permintaan pemeriksaan berhasil disimpan");
          storeRujukanDotsHiv.getByRegister(this.register);
          // Refresh detail
          const detailResp = await RujukanDotsHivSvc.find(this.editingId);
          if (detailResp.data.status == "1") {
            this.detailData = detailResp.data.data;
          }
        }
      }
    } finally {
      this.saving = false;
    }
  }

  // Signing

  signConsentKonselor() {
    if (!this.editingId) return;
    this.signPhase = "konselor";
    this.modalTtd = true;
  }

  signPermintaanDokter() {
    if (!this.editingId) return;
    this.signPhase = "dokter";
    this.modalTtd = true;
  }

  async handleSign(password: string) {
    try {
      let resp;
      if (this.signPhase === "konselor") {
        // First save the consent form
        await this.simpanConsent();
        // Mark pasien signature
        await RujukanDotsHivSvc.markPasien(this.editingId!, {});
        // Sign as konselor
        resp = await RujukanDotsHivSvc.signKonselor(this.editingId!, { password });
      } else {
        // Save permintaan first
        await this.simpanPermintaan();
        // Sign as dokter
        resp = await RujukanDotsHivSvc.signDokter(this.editingId!, { password });
      }

      if (resp.data.status == "1") {
        this.modalTtd = false;
        appModule.NoticeDelay(resp.data.message);
        appModule.addMsgTtd("");
        await storeRujukanDotsHiv.getByRegister(this.register);
        // Refresh detail
        const detailResp = await RujukanDotsHivSvc.find(this.editingId!);
        if (detailResp.data.status == "1") {
          this.detailData = detailResp.data.data;
          // Auto advance stepper after consent signed
          if (this.signPhase === "konselor" && this.detailData.consent_bersedia === true) {
            this.stepper = 2;
            // Auto-check skrining_sudah_ttd since consent was signed
            this.form.skrining_sudah_ttd = true;
          }
        }
      } else {
        appModule.addMsgTtd(resp.data.message);
        this.modalTtd = true;
      }
    } catch {
      // ErrorAlert already shown by service
    }
  }

  // Delete

  async remove(item) {
    if (!confirm("Yakin ingin menghapus data ini?")) return;
    const resp = await RujukanDotsHivSvc.destroy(item.id);
    if (resp && resp.status == 1) {
      appModule.NoticeDelay("Berhasil menghapus data");
      storeRujukanDotsHiv.getByRegister(this.register);
    }
  }

  // PDF

  cetakPdf(item) {
    RujukanDotsHivSvc.print(item.id);
  }
}
